import api from './api';

export const authService = {
  login: async (email, password, tenantSlug) => {
    try {
      const response = await api.post('/auth/login', 
        { email, password },
        { headers: { 'X-Tenant-Slug': tenantSlug } }
      );
      return response.data;
    } catch (error) {
      console.error('authService.login error:', error);
      throw error;
    }
  },

  logout: async () => {
    const response = await api.post('/auth/logout');
    return response.data;
  },

  refreshToken: async () => {
    const response = await api.post('/auth/refresh');
    return response.data;
  },

  getCurrentUser: async () => {
    const response = await api.get('/auth/me');
    return response.data; // Backend returns user object directly
  },
};

export const userService = {
  getUsers: async (page = 1, perPage = 20) => {
    const response = await api.get(`/users/?page=${page}&per_page=${perPage}`);
    return response.data;
  },

  createUser: async (userData) => {
    const response = await api.post('/users/', userData);
    return response.data;
  },

  updateUser: async (userId, userData) => {
    const response = await api.put(`/users/${userId}`, userData);
    return response.data;
  },

  deleteUser: async (userId) => {
    const response = await api.delete(`/users/${userId}`);
    return response.data;
  },
};

export const tenantService = {
  getTenants: async (page = 1, perPage = 20) => {
    const response = await api.get(`/tenants?page=${page}&per_page=${perPage}`);
    return response.data;
  },

  createTenant: async (tenantData) => {
    const response = await api.post('/tenants', tenantData);
    return response.data;
  },

  updateTenant: async (tenantId, tenantData) => {
    const response = await api.put(`/tenants/${tenantId}`, tenantData);
    return response.data;
  },

  deleteTenant: async (tenantId) => {
    const response = await api.delete(`/tenants/${tenantId}`);
    return response.data;
  },
};

export const adminService = {
  getDashboard: async () => {
    const response = await api.get('/admin/dashboard');
    return response.data;
  },

  getAuditLogs: async (page = 1, perPage = 50, filters = {}) => {
    const params = new URLSearchParams({
      page: page.toString(),
      per_page: perPage.toString(),
      ...filters,
    });
    const response = await api.get(`/admin/audit-logs?${params}`);
    return response.data;
  },

  getSystemInfo: async () => {
    const response = await api.get('/admin/system-info');
    return response.data;
  },
};